import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import api from './api';
import rootReducer from './reducers';

const configureStore = () => {
  const middlewares = [thunk, api];

  return createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
    applyMiddleware(...middlewares)
  );
};

export default configureStore;


// WEBPACK FOOTER //
// ./src/configureStore.js